import { apiClient, type SiteWithAreaEntity } from '@/libs/api'

export type FetchRecursiveQuery = {
  tenantKey: string
  dcId?: number
}

// 配下エリアまでのすべての紐づく地点の取得
export const fetchRecursive = async (
  { tenantKey, dcId }: FetchRecursiveQuery,
  id: number,
  signal?: AbortSignal
): Promise<SiteWithAreaEntity[]> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .areas._id(id)
    .recursive.$get({
      query: dcId ? { dcId } : undefined,
      config: {
        signal
      }
    })
  return data
}
